import { render } from "./NewTask.vue?vue&type=template&id=bdef8d7a&scoped=true"
import script from "./NewTask.vue?vue&type=script&lang=js"
export * from "./NewTask.vue?vue&type=script&lang=js"

import "./NewTask.vue?vue&type=style&index=0&id=bdef8d7a&lang=scss&scoped=true"
import "./NewTask.vue?vue&type=style&index=1&id=bdef8d7a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdef8d7a"]])

export default __exports__